module.exports = __webpack_public_path__ + "img/mercitalia-logo.bd7d673c.png";